import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTwitter,
    faGithub,
    faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import '../styles/Profile.css';
import Typist from 'react-typist';
import { Link } from "react-router-dom";

export default function Profile() {

    return (
        <div className="content-bg my-5 p-3" style={{ overflow: "hidden" }}>
            <div className="d-flex flex-row justify-content-between">
                <img src="images/arabank.png" alt="logo" width="70" height="70" className="logo ml-3 mt-4" />
            </div>
            <div className="background-label text-uppercase">
                Profile
            </div>
            <div className="container">
                <div className="d-flex flex-row justify-content-between">
                    <div className="intro">
                        <Typist>
                            Hi,<br />I'm Sodiq, <br />Web Developer.
                            <Typist.Delay ms={2000} />
                            <Typist.Backspace count={14} />
                            <span>App Developer.</span>
                        </Typist>
                    </div>
                    <img src="images/sodiq_1.png" alt="sodiq_image" width="550" height="700" className="sodiq_image mt-4" />
                </div>
            </div>
            <div className="p-5">
                <div className="icons">
                    <div className="d-flex flex-column">
                        <Link
                            className="text-white"
                            to={"https://github.com/Oleariyah"}
                            target="_blank"
                            onClick={(e) => {
                                e.preventDefault();
                                window.open("https://github.com/Oleariyah");
                            }}>
                            <FontAwesomeIcon icon={faGithub} size="lg" className="my-3" />
                        </Link>
                        <Link
                            className="text-white"
                            to={"https://www.linkedin.com/in/oleariyah/"}
                            target="_blank"
                            onClick={(e) => {
                                e.preventDefault();
                                window.open("https://www.linkedin.com/in/oleariyah/");
                            }}>
                            <FontAwesomeIcon icon={faLinkedin} size="lg" className="my-3" />
                        </Link>
                        <Link
                            className="text-white"
                            to={"https://twitter.com/oleariyah"}
                            target="_blank"
                            onClick={(e) => {
                                e.preventDefault();
                                window.open("https://twitter.com/oleariyah");
                            }}>
                            <FontAwesomeIcon icon={faTwitter} size="lg" className="my-3" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
